import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';

const TextLink = ({
  underline = false,
  className = '',
  variant = 'primary',
  'data-cy': dataCy,
  text,
  onClick,
  disabled,
  children,
}) => (
  <Button
    ghost
    className={`text-link bg-transparent p-0 ${underline ? 'underline' : ''} ${className}`}
    variant={variant}
    data-cy={dataCy}
    onClick={onClick}
    disabled={disabled}
  >
    {text
      ? <span className='fw-normal'>{text}</span>
      : children
    }
  </Button>
);

TextLink.propTypes = {
  underline: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.string,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.any,
  'data-cy': PropTypes.string,
};

export default TextLink;
